import { formatDate, formatDate_dd_mm_yyyy } from 'utils/DateFormatter'
import React, { useEffect, useState } from 'react'
import AddDelinquency from './AddDelinquency'
import { getMasterdataNames, getMasterdata } from './apis'
import {
  sentenceTypeOptions,
  trialStatusOptions,
} from './delinquencies_constants'




const concateDuration = (years, months, days) => {

  const duration = `${years} years ${months} months ${days} days`;

  return duration;
};

// const concateDuration = (years, months, days) => {
//   const duration = `${days} DD ${months} MM ${years} YYYY`;

//   return duration;
// };


const FirTable = ({ payload, onSuccess }) => {
  const [showModal, setShowModal] = useState(false)
  const [editingData, setEditingData] = useState()
  const [enrichedData, setEnrichedData] = useState(null)

  useEffect(() => {
    const enrichData = async () => {
      if (!payload) return

      const { data, created_date, id, empId, updated_date } = payload


      console.log("data",data)
      const newData = {
        ...data,
        policeStation: data?.policeStation != 'other' ?
          await getMasterdataNames(data.policeStation)
          : data?.otherPoliceStation,

        section: await Promise.all(
          (data?.section || []).map(async (sec) => {
            if (sec === "other") {
              // return
              return data?.otherSection
              // return data?.otherSection : uncomment if other section needs to include in section

            }
            return await getMasterdataNames(sec)
          })
        ),

        firDate: formatDate_dd_mm_yyyy(data?.firDate),
        challanDate: formatDate_dd_mm_yyyy(data?.challanDate),
        challanCctnsDate: formatDate_dd_mm_yyyy(data?.challanCctnsDate),


        ...(data?.trialStatus && {
          trialStatus: trialStatusOptions.find(
            (opt) => opt.value === data?.trialStatus
          )?.label,
        }),
        ...(data?.sentenceType && {
          sentenceType: sentenceTypeOptions.find(
            (opt) => opt.value === data?.sentenceType
          )?.label,
        }),
        ...(data?.sentenceType === "imprisonment" && {
          imprisonmentDurationMonths: concateDuration(
            data?.imprisonmentDurationYears,
            data?.imprisonmentDurationMonths,
            data?.imprisonmentDurationDays
          ),
        }),
        ...(data?.sentenceType === "bothImprisonmentAndFine" && {
          bothSentenceMonths: concateDuration(
            data?.bothSentenceYears,
            data?.bothSentenceMonths,
            data?.bothSentenceDays
          ),
        }),
      }

      setEnrichedData({
        data: newData,
        created_date,
        updated_date,
        id,
        empId,
      })
    }

    enrichData()
  }, [payload])

  // safe destructure
  const { data = {}, created_date, updated_date, id, empId } = enrichedData || {}

  const handleOpenModal = (data = null) => {
    setEditingData(data)
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setEditingData(null)
    setShowModal(false)
  }

  const refetch = () => {
    onSuccess(empId)
  }

  const formatValue = (key, value) => {
    const statusFields = [
      'status',
      'challanSubmitted',
      'chargesFramed',
      'trialStatus',
      'judgmentOutcome',
      'sentenceType',
    ]

    if (statusFields.includes(key)) {
      let badgeClass = 'badge rounded-pill '
      let displayValue = value

      switch (key) {
        case 'status':
          badgeClass +=
            value === 'challan' ? 'bg-success' : 'bg-warning text-dark'
          displayValue = value === 'challan' ? 'Challan Submission' : value
          break
        case 'challanSubmitted':
        case 'chargesFramed':
          badgeClass += value === 'yes' ? 'bg-success' : 'bg-danger'
          displayValue = value === 'yes' ? 'Yes' : 'No'
          break
        case 'trialStatus':
          badgeClass +=
            value === 'trialCompleted' ? 'bg-success' : 'bg-warning text-dark'
          displayValue = value === 'trialCompleted' ? 'Trial Completed' : value
          break
        case 'judgmentOutcome':
          badgeClass +=
            value === 'convicted'
              ? 'bg-danger'
              : value === 'acquitted'
                ? 'bg-success'
                : 'bg-secondary'
          displayValue = value
          break
        case 'sentenceType':
          badgeClass += 'bg-primary'
          displayValue = value
          break
      }

      return <span className={badgeClass}>{displayValue}</span>
    }

    return value ?? '-' // fallback if null/undefined
  }

  // 👇 filter groupedData so that only keys present in data will be shown
  const groupedData = [
    // Row 1
    [
      { key: 'firNumber', label: 'FIR Number' },
      { key: 'firDate', label: 'FIR Date' },
    ],
    [
      { key: 'policeStation', label: 'Police Station' },
      { key: 'status', label: 'Status' },
    ],

    [
      { key: 'section', label: 'Section' },

    ],

    [
      {
        key: 'untracedCctnsDate',
        label: 'Date of submission of final report in CCTNS',
      },
      { key: 'untracedOutcome', label: 'Outcome' },
    ],

    [
      {
        key: 'cancellationCctnsDate',
        label: 'Date of submission of final report in CCTNS',
      },
      { key: 'cancellationOutcome', label: 'Outcome' },
    ],

    [
      {
        key: 'challanCctnsDate',
        label: 'Date of submission of final report in CCTNS',
      },
      {
        key: 'challanSubmitted',
        label: 'Is challan submitted in court ?',
      },
    ],
    [
      { key: 'challanDate', label: 'Date of submission of challan in court' },
      { key: 'chargesFramed', label: 'Charges framed in court' },
    ],
    [
      { key: 'chargesDate', label: 'Date of framing of charges by court' },
      { key: 'trialStatus', label: 'Trial Status' },
    ],
    [
      { key: 'judgmentOutcome', label: 'Judgment Type' },
      { key: 'judgmentDate', label: 'Date of Judgment' },
    ],
    [{ key: 'sentenceType', label: 'Sentence Type' }],
    [
      { key: 'imprisonmentDurationMonths', label: 'Imprisonment Duration' },
      { key: 'fineAmount', label: 'Fine amount' },
    ],
    [
      { key: 'bothSentenceMonths', label: 'Imprisonment Duration' },
      { key: 'bothSentenceFine', label: 'Fine' },
    ],
    [
      { key: 'allegations', label: 'Allegations' },
      { key: 'remarks', label: 'Remarks' },
    ],
  ]

  if (!data) return <p className="text-center">No FIR Data Found</p>

  return (
    <div className="container py-4">
      <div className="card shadow mb-4">
        <div className="card-header ms-3 me-3 mt-3 bg-dark rounded text-white text-center">
          <div className="d-flex align-items-center justify-content-between ">
            <h5 className="mb-0 text-white">
              Criminal Case Details - Case #{data.firNumber}
            </h5>
            {!["ADMIN", "SUPERADMIN"].includes(
              localStorage.getItem("role"),
            ) && (
              <button
                type="button"
                onClick={() => handleOpenModal(id)}
                className="btn btn-outline-white text-white btn-lg px-3 py-2 shadow-sm"
                style={{ textDecoration: "none" }}
              >
                Update
              </button>
            )}
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered align-middle">
              <tbody>
                {groupedData.map((row, rowIndex) => {
                  const filteredRow = row.filter(
                    (cell) => data[cell.key] !== undefined
                  )

                  // Single item in the original row definition
                  if (row.length === 1 && filteredRow.length === 1) {
                    return (
                      <tr key={rowIndex}>
                        <th className="bg-light">{filteredRow[0].label}</th>
                        <td colSpan={3}>
                          {formatValue(
                            filteredRow[0].key,
                            data[filteredRow[0].key]
                          )}
                        </td>
                      </tr>
                    )
                  }

                  // Multiple items in row - normal rendering
                  return (
                    <tr key={rowIndex}>
                      {filteredRow.map((cell, cellIndex) => (
                        <React.Fragment key={cellIndex}>
                          <th className="bg-light">{cell.label}</th>
                          <td>{formatValue(cell.key, data[cell.key])}</td>
                        </React.Fragment>
                      ))}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="card-footer text-muted text-center small d-flex justify-content-between ">
          <span>
            Created Date: {formatDate_dd_mm_yyyy(created_date)}
          </span>
          <span>
            Last Updated Date: {formatDate_dd_mm_yyyy(updated_date)}
          </span>
        </div>

      </div>
      <AddDelinquency
        showModal={showModal}
        editingData={editingData}
        onSuccess={refetch}
        handleCloseModal={handleCloseModal}
        empId={empId}
      />
    </div>
  )
}

export default FirTable
